import script from "./CandyBoxViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./CandyBoxViewer.vue?vue&type=script&setup=true&lang=js"

import "./CandyBoxViewer.vue?vue&type=style&index=0&id=3bceb6e7&lang=css"

const __exports__ = script;

export default __exports__